export const FormatNumber = (numberToFormat) => {
  const res = Number(numberToFormat).toLocaleString("en-US", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
  return res;
};
